import { Button } from '@progress/kendo-react-buttons';
import { useState } from 'react';
import { FaList } from 'react-icons/fa';
import { LuLogOut } from 'react-icons/lu';
import { MdEmail } from 'react-icons/md';

export default function ProfileDropdown({logout,email}) {
  const [isOpen, setIsOpen] = useState(false);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="dropdown-container">
      {/* Profile Icon */}
      <div
        className="profile-icon"
        onClick={toggleDropdown}
      >
        <FaList/>
      </div>

      {/* Dropdown Menu */}
      {isOpen && (
        <div className="dropdown-menu">


          <div className="menu-item">
            <div className="menu-icon">
              <MdEmail/>
            </div>
            <div className="menu-text">{email}</div>
          </div>


          <Button className="k-button-red2" style={{width:'100%'}} onClick={()=>logout()}>
            <LuLogOut style={{position:'relative',top:'4px',right:'10px',fontSize:'1.1rem'}}/>
          Sign out

          </Button>

        </div>
      )}

      {/* Invisible overlay to handle closing when clicking outside */}
      {isOpen && (
        <div
          className="overlay-logout"
          onClick={toggleDropdown}
        />
      )}

      <style jsx>{`
        /* Container positioning */
        .dropdown-container {
          position: relative;
          display: inline-block;
        }
        
        /* Profile icon styling */

        
   .profile-icon{
    padding-top: 5px;
   }
        
        /* Dropdown menu */
        .dropdown-menu {
          position: absolute;
          top: 50px;
          right: 0;
          width: 300px;
          background-color: white;
          border-radius: 8px;
          box-shadow: 0 12px 28px 0 rgba(0, 0, 0, 0.2);
          padding: 12px;
          z-index: 1000;
          animation: dropdown 0.3s ease forwards;
        }
        
        @keyframes dropdown {
          from {
            opacity: 0;
            transform: translateY(-10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        

        
        /* Menu items */
        .menu-item {
          display: flex;
          align-items: center;
          padding: 12px 8px;
          border-radius: 6px;
          cursor: pointer;
          transition: background-color 0.2s;
        }
        
        .menu-item:hover {
          background-color: #f2f2f2;
        }
        
        .menu-icon {
          width: 36px;
          height: 36px;
          border-radius: 50%;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-right: 5px;
        }
        
        .menu-text {
          font-size: 14px;
          color: #050505;
        }
        
        /* Sign out button */
        .signout-button {
          width: 100%;
          padding: 8px;
          border-radius: 6px;
          border: none;
          background-color: #f2f2f2;
          margin-top: 8px;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          font-size: 14px;
          color: #050505;
          transition: background-color 0.2s;
        }
        
        .signout-button:hover {
          background-color: #e4e6eb;
        }
        
        .signout-icon {
          margin-right: 8px;
        }
        

        
        /* Overlay for closing */
        .overlay-logout {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: transparent;
          z-index: 999;
        }
      `}</style>
    </div>
  );
}
